export const UPDATE_CUSTOM_INSIGHT = 'update_custom_insight';
export const UPDATE_CUSTOM_INSIGHT_ARRAY = 'update_custom_insight_array';
export const REMOVE_CUSTOM_INSIGHT_ARRAY_ITEM = 'remove_custom_insight_array_item';
export const ADD_NAMING_CONVENTION = 'add_naming_convention';
export const REMOVE_NAMING_CONVENTION = 'remove_naming_convention';
export const ADD_CUSTOM_INSIGHT = 'add_custom_insight';
export const DELETE_CUSTOM_INSIGHT = 'delete_custom_insight';
export const DISCARD_NEW_CUSTOM_INSIGHT = 'discard_new_custom_insight';
